module.exports = __webpack_public_path__ + "img/lpr_day_down.7ea855bd.svg";